export * from './useProductDetailsTabs';
